<app-entity-page
[closeClicked]="closeClicked"
[switchToMapTab]="switchToMapTab"
[detailsContentTitle]="getDetailsTitle()"
[mapContentTitle]="getMapTitle()"
[loading]="excavationDetailsIsLoading">
  <ng-template #detailsContent>
    <div class="excavation-content">
      <div class="excavation-content-body">
        <excavation-details 
          class="excavation-details" 
          [selectedExcavation]="selectedExcavationDetails" 
          [currentLanguage]="currentLanguage$"
          [selectedEntityId]="selectedEntityId"
          (highlightShape)="highlightShape($event.entityId, $event.entityType)">
        </excavation-details>
      </div>
    </div>
  </ng-template>
  
  <ng-template #mapContent>
    <div class="excavation-map">
      <app-arcgis-map 
        [shapes]="shapes" 
        [mapControls]="mapControls" 
        [extentAll]="true" 
        [popupEnabled]="true" 
        [lang]="currentLanguage"
        [selectedEntityId]="selectedEntityId">
      </app-arcgis-map>
    </div>
  </ng-template>
  <ng-template #footer>
    <div class="info-container" style="border-bottom:none">
      <div class="info-items-container">
        <div class="info-title">{{'iaa.app.excavation.additionalInformation' | translate }}</div>
        <div class="item-container">
          <img class="link-icon" src="assets/excavations-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             [class.disabled]="!hasExcavationPolygon()"
             [attr.tabindex]="hasExcavationPolygon() ? 0 : -1"
             [attr.aria-disabled]="!hasExcavationPolygon()"             
             [attr.aria-label]="'iaa.app.excavation.excavationsInArea' | translate"
             (click)="hasExcavationPolygon() && goToExcavations()"
             (keydown.enter)="hasExcavationPolygon() && goToExcavations()"
              (keydown.space)="hasExcavationPolygon() && goToExcavations(); $event.preventDefault()">{{'iaa.app.excavation.excavationsInArea' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/surveys-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             [class.disabled]="!hasExcavationPolygon()"
             [attr.tabindex]="hasExcavationPolygon() ? 0 : -1"
             [attr.aria-label]="'iaa.app.survey.surveysInArea' | translate"
             [attr.aria-disabled]="!hasExcavationPolygon()"
             (click)="hasExcavationPolygon() && goToSurveys()"
             (keydown.enter)="hasExcavationPolygon() && goToSurveys()"
             (keydown.space)="hasExcavationPolygon() && goToSurveys(); $event.preventDefault()">{{'iaa.app.survey.surveysInArea' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/loci-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             tabindex="0"
             [attr.aria-label]="'iaa.app.excavation.lociBaskets' | translate"
             (click)="goToLociBaskets()"
             (keydown.enter)="goToLociBaskets()"
             (keydown.space)="goToLociBaskets(); $event.preventDefault()">{{'iaa.app.excavation.lociBaskets' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/sites-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
              [class.disabled]="!hasExcavationPolygon()"
              [attr.tabindex]="hasExcavationPolygon() ? 0 : -1"
              [attr.aria-disabled]="!hasExcavationPolygon()"             
              role="button" 
             [attr.aria-label]="'iaa.app.excavation.sites' | translate"
             (click)="hasExcavationPolygon() && goToSites()"
             (keydown.enter)="hasExcavationPolygon() && goToSites()"
             (keydown.space)="hasExcavationPolygon() && goToSites(); $event.preventDefault()">{{'iaa.app.excavation.sites' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/objects-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             tabindex="0"
             [attr.aria-label]="'iaa.app.excavation.objects' | translate"
             (click)="goToObjects()"
             (keydown.enter)="goToObjects()"
             (keydown.space)="goToObjects(); $event.preventDefault()">{{'iaa.app.excavation.objects' | translate}}</a>
        </div>
        <div class="item-container">
          <img class="link-icon" src="assets/archive-icon.svg" alt="" role="presentation" />
          <a class="info-item" 
             role="button" 
             tabindex="0"
             [attr.aria-label]="'iaa.app.excavation.archiveDocuments' | translate"
             (click)="goToArchiveDocuments()"
             (keydown.enter)="goToArchiveDocuments()"
             (keydown.space)="goToArchiveDocuments(); $event.preventDefault()">{{'iaa.app.excavation.archiveDocuments' | translate}}</a>
        </div>
      </div>
    </div>
  </ng-template>
</app-entity-page>
